import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import styles from './CampaignCard.module.scss'

const WidgetCampaignCard = ({ title, description, campaignName, onClick }) => {
  const content = (
    <>
      <div className={styles.title}>{title}</div>
      <div className={styles.description}>{description}</div>
    </>
  )

  if (onClick) {
    return (
      <div className={styles.card} onClick={onClick} style={{ cursor: 'pointer' }}>
        {content}
      </div>
    )
  }

  return (
    <Link className={styles.card} to={`editCampaign/sales/${campaignName}`}>
      {content}
    </Link>
  )
}

WidgetCampaignCard.propTypes = {
  title: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  campaignName: PropTypes.string,
  onClick: PropTypes.func
}

export default WidgetCampaignCard
